<template>
<div class="mfa-otp animated fade-in bg-white-transparent-1" data-pageload-addclass="animated fadeIn">
        <div class="system-version"></div>
        <div class="mfa-header">
            <p>Please enter the one-time-passcode sent to your email account.</p>
        </div>
        <!-- begin mfa-content -->
        <div class="mfa-content">
          <div class="data-form">
              <div class="form-group">
              <v-text-field
                name="mfaCaptcha"
                label="One-time code"
                type="numbers"
                v-model="data.captcha"
                class="custom-text-field"
                ref="captchaField"
              ></v-text-field>
            </div>
          </div>
          <div class="float-right">
          <div style="display:block">
              <a class="text-email">Didn't receive the email?</a> <span v-if="!isExpired" class="text-red">({{ timer }}s)</span>
              <a v-if="isExpired" @click.prevent="handleResendCaptcha" class="resend-link">Resend</a>
            </div>
            <v-btn
          color="blue"
          text
          @click="verifyOtp"
          class="mt-20"
          >
          Submit
        </v-btn>
        <v-btn color="blue darken-1" text @click="hideMFADialog" class="mt-20">
        Cancel
      </v-btn>
          </div>
        </div>
        <!-- end mfa-content -->
</div>
</template>

<script>
import { AuthApi } from '@/api/pandaria'
import { Tool, Cache, Popup } from '@/util/index'
const cache = new Cache()
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'MFACard',
  props: {
    email: String
  },
  data () {
    return {
      layoutData: {
        isLoading: false
      },
      data: {
        captcha: ''
      },
      timer: 60,
      interval: null,
      isExpired: false
    }
  },
  methods: {
    startTimer () {
      this.timer = 60
      this.isExpired = false
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1
        } else {
          this.isExpired = true
          clearInterval(this.interval)
        }
      }, 1000)
    },
    hideMFADialog () {
      this.data.captcha = ''
      this.$emit('hideMFADialog')
    },
    async verifyOtp () {
      const $this = this
      try {
        if (tool.isEmpty(this.data.captcha)) {
          $this.$swal({ type: 'info', text: 'Please enter captcha', showCancelButton: false })
        } else {
          const verifyOTPRequest = { captcha: this.data.captcha, email: this.email }
          await AuthApi.verifyCaptcha(verifyOTPRequest, function (data) {
            cache.setAccessToken(data)
            window.getApp.$emit('APP_LOGIN_SUCCESS')
          }, function (result) {
            throw result.message
          }
          )
        }
      } catch (e) {
        popup.popupForWarning(e, null, function () {
          $this.layoutData.isLoading = false
        })
      }
    },
    handleResendCaptcha (event) {
      if (!this.isExpired) {
        event.preventDefault()
        return
      }
      this.resendCaptcha()
    },
    resendCaptcha () {
      const verifyOTPRequest = { email: this.email }
      AuthApi.resendCaptcha(verifyOTPRequest, function (data) {
        cache.setAccessToken(data)
      }, function (result) {
        throw result.message
      })
      this.startTimer()
    }
  },
  mounted () {
    this.startTimer()
    this.$nextTick(() => {
      const element = this.$refs.captchaField.$el
      const label = element.querySelector('.v-label.theme--light')
      if (label) {
        label.style.setProperty('color', 'white', 'important')
      }
      const outline = element.querySelector('.theme--light.v-input input, .theme--light.v-input textarea')
      if (outline) {
        outline.style.borderBottom = '2px solid #FFFFFF'
        outline.style.setProperty('color', '#FFFFFF', 'important')
      }
    })
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
}
</script>

<style scoped lang="css">
    .mfa-otp {
  width: 500px;
  position: absolute;
  top: 30%;
  bottom: 30%;
  right: 30%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  color: #ccc;
  background-color: rgba(204, 204, 204, 0.24);
}
.mfa-otp .mfa-header {
  width: initial;
  padding: 0 20px;
  margin: 0;
  top: 0;
  left: 0;
  right: 0;
  position: relative;
  font-weight: 300;
  color: #fff;
}
.mfa-otp .mfa-header {
  padding: 0 20px;
  font-size: 14px;
  color: #fff;
}
.mfa-otp .mfa-content {
  padding: 0 20px;
  color: white !important;
  width: initial;
  margin: initial;
}
.v-application .primary--text
{
  border-style: none;
  color: white !important;
  caret-color: white !important;
}
.text-red {
  color: red
}
.v-application a{
  color:initial;
}
.mt-20{
  margin-top: 20px;
}
.v-application a{
  color:initial;
}
.resend-link {
  color:#2196F3 !important;
  text-decoration: underline;
  cursor: pointer;
}
.text-email {
  color: white !important;
  pointer-events: none;
}
</style>
